export default "__VITE_ASSET__Cuhibvc7__"